const defaultPaginationDetails = {
  currentPage: 0,
  totalPages: 0,
  pageSize: 0,
  totalData: 0,
};

const initialPrescriptionQueueFilters = {
  generatedId: undefined,
  locationName: undefined,
  patientName: undefined,
  purchaseCreatedAt: "",
  createdBy: undefined,
  assignedTo: undefined,
};

export default {
  defaultPaginationDetails,
  preOrdersCart: {
    data: [],
    paginationDetails: defaultPaginationDetails,
  },
  prescriptionCart: {
    data: null,
    fulfillmentsShippings: [],
    userLicenses: [],
  },

  prescriptionQueue: {
    data: [],
    filters: initialPrescriptionQueueFilters,
    paginationDetails: defaultPaginationDetails,
  },

  prescriptionQueuesCount: {
    pendingApproval: 0,
    approved: 0,
    prescriberDecline: 0,
  },
  taxCalculation: {},
};
